export default __webpack_public_path__ + "muppets.bb8e84d5.png";